/**
 * Enter commits a field the same way as leaving it.
 * @param {React.KeyboardEvent<HTMLInputElement>} event
 */
export const blurOnEnter = (event) => {
  if (event.key === "Enter") event.currentTarget.blur();
};
